/**
 * Module State Initialization Utilities
 *
 * Shared utilities for initializing Redux module state from URL parameters
 * Used by both app-level initialization and route-level initialization
 */

import { store } from 'redux/store';
import { navigateToEB, navigateToPC } from 'redux/actions/ModuleStateActions';
import { getModuleFromUrl } from 'lib/AppHelpers';

/**
 * Initialize Redux module state from URL
 *
 * @param url - Full URL to extract module from (optional, defaults to current URL)
 * @param moduleParam - Direct module parameter (e.g., from route params)
 * @returns void
 */
export function initializeModuleState(url?: string, moduleParam?: string): void {
  let module: string;

  if (moduleParam) {
    // Use direct module parameter (from route params)
    module =
      moduleParam.toLowerCase() === 'eb' ? 'EB' : moduleParam.toLowerCase() === 'pc' ? 'PC' : '';
  } else {
    // Extract module from URL
    module = getModuleFromUrl(url || window.location.href);
  }

  // Dispatch appropriate action
  if (module === 'EB') {
    store.dispatch(navigateToEB());
  } else if (module === 'PC') {
    store.dispatch(navigateToPC());
  }
}
